import { start } from "../app/start";

start();
